package com.nonopn.skywatcher.app.utils

import korlibs.io.async.async
import korlibs.time.DateTime
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.isActive
import kotlin.time.Duration

class Clock(
    private val scope: CoroutineScope
) {
    fun start(intervals: Duration): Flow<DateTime> = scope.count(intervals)

    private fun CoroutineScope.count(intervals: Duration): Flow<DateTime> {
        val flow: MutableStateFlow<DateTime> = MutableStateFlow(DateTime.now())

        async({
            try {
                while (isActive) {
                    flow.tryEmit(DateTime.now())

                    delay(intervals)
                }
            } catch (_: Throwable) {
                // nothing
            }
        })

        return flow
    }
}
